import WithdrawHistory from './WithdrawHistory';

export default WithdrawHistory;
